import { __spreadArray, __read } from 'tslib';
import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import { UitkRatingIcons } from './types.esm.js';
import styles from './uitk-rating.css';

var getClassNameList = classNames.bind(styles);
var UitkRating = function (props) {
    var a11yText = props.a11yText, _a = props.icon, icon = _a === void 0 ? 'star' : _a, rating = props.rating, className = props.className;
    var max = 5;
    var currentRating = Number(rating);
    if (currentRating > max || !currentRating) {
        currentRating > max && console.error("Maximum value is ".concat(max));
        return null;
    }
    var visuallyHiddenText = a11yText
        ? a11yText.replace(/%s/, "".concat(currentRating)).replace(/%d/, "".concat(max))
        : "".concat(currentRating, " out of ").concat(max);
    var ratingArr = Number.isInteger(currentRating)
        ? // @ts-ignore
         __spreadArray([], __read(Array(currentRating).keys()), false) : __spreadArray([], __read(Array(Math.floor(currentRating)).keys()), false).concat([currentRating - Math.floor(currentRating)]);
    var wrapperClassNames = getClassNameList('uitk-rating', className);
    var iconType = icon && UitkRatingIcons.get(icon);
    return (React.createElement("div", { className: wrapperClassNames },
        React.createElement("span", { className: "is-visually-hidden" }, visuallyHiddenText),
        ratingArr.map(function (val, index) { return (React.createElement(UitkIcon, { name: Number.isInteger(val) ? "".concat(iconType) : "".concat(iconType, "_half"), size: UitkIconSize.EXTRA_SMALL, key: index, className: getClassNameList('uitk-rating-icon') })); })));
};

export { UitkRating };
